import { render } from "./settings_api.vue?vue&type=template&id=9779cd7a&scoped=true"
import script from "./settings_api.vue?vue&type=script&lang=js"
export * from "./settings_api.vue?vue&type=script&lang=js"

import "./settings_api.vue?vue&type=style&index=0&id=9779cd7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9779cd7a"]])

export default __exports__